const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const areasService = {
  // Obtener todas las áreas
  async getAll() {
    try {
      const response = await fetch(`${API_URL}/areas`);
      if (!response.ok) {
        throw new Error('Error al obtener las áreas');
      }
      return await response.json();
    } catch (error) {
      console.error('Error al obtener las áreas:', error);
      throw error;
    }
  },

  // Obtener áreas con filtros y paginación
  async getWithFilter({ limit, offset, query }) {
    try {
      const response = await fetch(`${API_URL}/areas/filter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ limit, offset, query }),
      });
      
      if (!response.ok) {
        throw new Error('Error al obtener las áreas');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error al obtener las áreas:', error);
      throw error;
    }
  },

  // Obtener área por ID
  async getById(id) {
    try {
      const response = await fetch(`${API_URL}/areas/${id}`);
      if (!response.ok) {
        throw new Error('Error al obtener el área');
      }
      return await response.json();
    } catch (error) {
      console.error('Error al obtener el área:', error);
      throw error;
    }
  },

  // Crear nueva área
  async create(areaData) {
    try {
      const response = await fetch(`${API_URL}/areas`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(areaData),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al crear el área');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error al crear el área:', error);
      throw error;
    }
  },

  // Actualizar área
  async update(id, areaData) {
    try {
      const response = await fetch(`${API_URL}/areas/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(areaData),
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al actualizar el área');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error al actualizar el área:', error);
      throw error;
    }
  },

  // Eliminar área
  async delete(id) {
    try {
      const response = await fetch(`${API_URL}/areas/${id}`, {
        method: 'DELETE',
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al eliminar el área');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error al eliminar el área:', error);
      throw error;
    }
  },

  // Exportar áreas
  async export(query = {}) {
    try {
      const response = await fetch(`${API_URL}/areas/export`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(query),
      });
      
      if (!response.ok) {
        throw new Error('Error al exportar las áreas');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error al exportar las áreas:', error);
      throw error;
    }
  },
};
